import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MarketingContent } from "src/app/core/services/myqq";

@Component({
  selector: "myqq-marketing-content",
  templateUrl: "./marketing-content.component.html",
  styleUrls: ["./marketing-content.component.css"],
})
export class MarketingContentComponent {
  @Input() marketingContent: MarketingContent;
  @Output() clickCard = new EventEmitter();

  showCard = true;

  handleDismissCard() {
    this.showCard = false;
  }
}
